import { put } from 'redux-saga/effects'
import { deleteFollowupAction, fetchFollowupsByOperatorAction } from '../../handles'
import { deleteFollowup } from '../_http/followup'

export function* deleteFollowupSaga(action: ReturnType<typeof deleteFollowupAction.request>) {
  const { followupId, companyId, ownerId, operatorId } = action.payload
  try {
    yield deleteFollowup(followupId)
    yield put(deleteFollowupAction.success())

    if (companyId && ownerId) {
      yield put(fetchFollowupsByOperatorAction.request({ companyId, ownerId, operatorId, page: 1 }))
    }
  } catch (error) {
    yield put(deleteFollowupAction.failure())
  }
}
